import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckpublicGuard } from '../guards/checkpublic.guard';

import { AuthenticationComponent } from './authentication/authentication.component'
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { ForgotpasswordConfirmationComponent } from './forgotpassword-confirmation/forgotpassword-confirmation.component';
import { ResendemailConfirmationComponent } from './resendemail-confirmation/resendemail-confirmation.component';
import { SignupConfirmationComponent } from './signup-confirmation/signup-confirmation.component';
import { LoginWayComponent } from './login-way/login-way.component';



const routes: Routes = [
  {
    path: '',
    component: AuthenticationComponent,
    canActivate: [CheckpublicGuard],
    children: [
      {
        path: '',
        canActivateChild: [CheckpublicGuard],
        children: [
          { path: 'login', component: LoginWayComponent },
          { path: 'signup', component: LoginWayComponent },

          { path: 'signup-success', component: LoginWayComponent },
          { path: 'forgot-password', component: LoginWayComponent },

          { path: 'forgot-password-success', component: LoginWayComponent },
          { path: 'reset-password', component: LoginWayComponent },

          { path: 'email-confirmation-instructions', component: LoginWayComponent },
          { path: 'email-confirmation-instructions-success', component: LoginWayComponent },

          { path: '', component: LoginWayComponent },
        ]
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
